import React from 'react';
import { Dialog } from "@progress/kendo-react-dialogs";
import { Form, Field, FormElement } from "@progress/kendo-react-form";
import { Button } from "@progress/kendo-react-buttons";
import { Label } from "@progress/kendo-react-labels";
import { Input } from "@progress/kendo-react-inputs";
import { ListView } from "@progress/kendo-react-listview";
import { DropDownList } from "@progress/kendo-react-dropdowns";

import {
    FormInput,
    FormCheckbox,
    FormDropDownList,
} from "../../forms/form-components";

export const AdministratorVenueEventAlertForm = (props) => {
    const fiftyCharacterRequiredValidator = (value) => {
        if (!value) {
            return "This field is required";
        }

        if (value.length > 50) {
            return "Maximum length is 50 characters";
        }

        return "";
    }

    const requiredValidator = (value) => {
        if (!value) {
            return "This field is required";
        }

        return "";
    }

    return (
        <Dialog
            title={props.item.venueEventAlertKey ? "Update Event Alert" : "Add Event Alert"}
            onClose={props.cancel}
            width={"90vw"}
        >
            <Form
                onSubmit={props.save}
                initialValues={props.item}   
                ignoreModified={true}
                render={(formRenderProps) => (
                    <FormElement>
                        <fieldset className={"k-form-fieldset container"}>
                            <div className="row">
                                <div className="col-md-6">
                                    <Field
                                        id={"venueEventAlertType"}
                                        name={"venueEventAlertType"}
                                        label={"Type"}
                                        component={FormDropDownList}
                                        data={props.venueEventAlertTypes}
                                        textField="name"
                                        dataItemKey="venueEventAlertTypeId"
                                        validator={requiredValidator}
                                    />
                                </div>
                                <div className="col-md-6">
                                    <Field
                                        id={"sectionName"}
                                        name={"sectionName"}
                                        label={"Section Name"}
                                        component={FormInput}
                                        validator={fiftyCharacterRequiredValidator}
                                    />
                                </div>                                
                            </div>
                            <div className="row">  
                                <div className="col-md-6">
                                    <Field
                                        id={"ticketCount"}
                                        name={"ticketCount"}
                                        label={"Trigger Count"}
                                        type={"number"}
                                        component={FormInput}
                                    />
                                </div>
                                <div className="col-md-6">
                                    <Field
                                        id={"isActive"}
                                        name={"isActive"}
                                        label={"Active"}
                                        component={FormCheckbox}
                                    />
                                </div>
                            </div>                          
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="k-form-field">
                                        <Label className="k-label">
                                            Alert Parameters
                                        </Label>
                                        <div className="k-form-field-wrap">
                                            <div className="row">
                                                <div className="col-md-5">
                                                    {props.ticketCountInputParameters.length > 0 ?
                                                        <DropDownList
                                                            data={props.ticketCountInputParameters}
                                                            
                                                            textField="name"
                                                            dataItemKey="name"
                                                            onChange={props.addEventAlertParameterKeyFromDropDownList}
                                                        />
                                                        :
                                                        <Input id={"eventAlertParameterKey"} onChange={props.addEventAlertParameterKeyFromInput} placeholder="Key" />
                                                    }
                                                </div>
                                                <div className="col-md-5">
                                                    <Input id={"eventAlertParameterValue"} onChange={props.addEventAlertParameterValue} placeholder="Value" />
                                                </div>
                                                <div className="col-md-2">
                                                    <Button 
                                                        type="button" 
                                                        themeColor={"primary"}                                                        
                                                        onClick={props.addEventAlertParameterWithoutInputs}>
                                                        Add
                                                    </Button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="k-form-field">
                                        <Label className="k-label">
                                            &nbsp;
                                        </Label>
                                        <div className="k-form-field-wrap">                                                            
                                            <ListView
                                                data={props.eventAlertParameters}
                                                item={props.eventAlertParameterRender}
                                                style={{
                                                    width: "100%",
                                                }}
                                                />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="k-form-field">
                                        <Label className="k-label">
                                            Select event parameters to use for this alert
                                        </Label>
                                        <div className="k-form-field-wrap">
                                            <ListView
                                                data={props.eventParameters}
                                                item={props.eventParameterRender}
                                                style={{
                                                    width: "100%",
                                                }}
                                                />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </fieldset>
                        <div className="k-form-buttons">
                            <Button
                                type={"submit"}
                                themeColor={"primary"}
                            >
                                Save
                            </Button>
                            <Button
                                type={"submit"}
                                onClick={props.cancel}
                            >
                                Cancel
                            </Button>
                        </div>
                    </FormElement>
                )}
            />
        </Dialog>
    );
}